import React from "react";
import modalStyles from "@/styles/Modal.module.scss";
import { Button } from "../Buttons";
import { useCallback, useEffect, useState, useRef, forwardRef } from "react";
import routes from "@/lib/routes";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ChatMessageReportStepInit = props => {
  // メッセージが通報済みかチェック
  const isReported = props.reportedMessageIds.includes(props.id);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("header", {
      children: /*#__PURE__*/_jsx("h3", {
        children: "\u30C1\u30E3\u30C3\u30C8\u5185\u5BB9"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: modalStyles.chatMessageDisplay,
      children: /*#__PURE__*/_jsxs("div", {
        className: modalStyles.chatMessage,
        children: [/*#__PURE__*/_jsx("span", {
          className: modalStyles.username,
          children: props.displayName
        }), /*#__PURE__*/_jsx("span", {
          className: modalStyles.messageContent,
          children: props.postDesc
        })]
      })
    }), /*#__PURE__*/_jsx(Button, {
      borderLight: true,
      fontFixed: true,
      fillWhiteColor: true,
      large: true,
      onClick: props.setStepReport,
      disabled: isReported,
      children: isReported ? "通報済み" : "通報する"
    }, "doReportButton"), /*#__PURE__*/_jsx(Button, {
      borderLight: true,
      fontFixed: true,
      fillWhiteColor: true,
      large: true,
      onClick: props.setStepMute,
      children: "\u975E\u8868\u793A\u306B\u3059\u308B"
    }, "doMuteButton"), /*#__PURE__*/_jsx(Button, {
      fontFixed: true,
      large: true,
      borderLight: true,
      onClick: props.modalCloseHandle,
      children: "\u9589\u3058\u308B"
    })]
  });
};
export default ChatMessageReportStepInit;